<script lang="ts">
  import Button from '@/components/button/Button.svelte';
  import editorStore from '../../editor.store';
  import {onDestroy} from 'svelte';
  import {tooltip} from '@/actions/tippy-action';
  import editorInstance from '../../editor';

  let activeComponent: HTMLElement;
  let isXFlipped = false;
  let isYFlipped = false;
  const unsubscribe = editorStore.subscribe(store => {
    if (activeComponent === store.activeComponent) return;
    activeComponent = store.activeComponent! as HTMLElement;
    if (!activeComponent) return;
    isXFlipped = activeComponent.style.transform.includes('scaleX(-1)');
    isYFlipped = activeComponent.style.transform.includes('scaleY(-1)');
  });

  const flipXImage = () => {
    if (!activeComponent) return;

    const currentTransform = activeComponent.style.transform;
    const hasScaleX = currentTransform.includes('scaleX(');

    // Toggle scaleX between -1 and 1
    if (isXFlipped) {
      activeComponent.style.transform = hasScaleX
        ? currentTransform.replace(/scaleX\(-?1\)/, 'scaleX(1)')
        : currentTransform + ' scaleX(1)';
    } else {
      activeComponent.style.transform = hasScaleX
        ? currentTransform.replace(/scaleX\(-?1\)/, 'scaleX(-1)')
        : currentTransform + ' scaleX(-1)';
    }

    editorInstance.history.addHistory('Flip X Image');
    isXFlipped = !isXFlipped;
  };

  const flipYImage = () => {
    if (!activeComponent) return;

    const currentTransform = activeComponent.style.transform;
    const hasScaleY = currentTransform.includes('scaleY(');

    // Toggle scaleY between -1 and 1
    if (isYFlipped) {
      activeComponent.style.transform = hasScaleY
        ? currentTransform.replace(/scaleY\(-?1\)/, 'scaleY(1)')
        : currentTransform + ' scaleY(1)';
    } else {
      activeComponent.style.transform = hasScaleY
        ? currentTransform.replace(/scaleY\(-?1\)/, 'scaleY(-1)')
        : currentTransform + ' scaleY(-1)';
    }

    editorInstance.history.addHistory('Flip Y Image');

    isYFlipped = !isYFlipped;
  };

  onDestroy(() => {
    unsubscribe();
  });
</script>

<div class="flex flex-row space-x-1">
  {#if isXFlipped}
    <div use:tooltip={'Unflip Horizontal'}>
      <Button
        icon="FlipRight"
        iconSize="small"
        className="p-2 bg-white rounded-md cursor-pointer text-xs flex justify-center items-center px-4 hover:bg-gray-100"
        on:click={flipXImage}
        on:keypress={flipXImage}
      />
    </div>
  {:else}
    <div use:tooltip={'Flip Horizontal'}>
      <Button
        icon="FlipLeft"
        iconSize="small"
        className="p-2 bg-white rounded-md cursor-pointer text-xs flex justify-center items-center px-4 hover:bg-gray-100"
        on:click={flipXImage}
        on:keypress={flipXImage}
      />
    </div>
  {/if}
  {#if isYFlipped}
    <div use:tooltip={'Unflip Vertical'}>
      <Button
        icon="FlipDown"
        iconSize="small"
        className="p-2 bg-white rounded-md cursor-pointer text-xs flex justify-center items-center px-4 hover:bg-gray-100"
        on:click={flipYImage}
        on:keypress={flipYImage}
      />
    </div>
  {:else}
    <div use:tooltip={'Flip Vertical'}>
      <Button
        icon="FlipUp"
        iconSize="small"
        className="p-2 bg-white rounded-md cursor-pointer text-xs flex justify-center items-center px-4 hover:bg-gray-100"
        on:click={flipYImage}
        on:keypress={flipYImage}
      />
    </div>
  {/if}
</div>
